import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * 성능/운엉 > 구성 > 구성현황  무선 AP 무선정보를 조회한다.
   * @author Hunui
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getWirelessApConfigInfo(params) {
    return axios.post(`${baseUrl}/config/get-wireless-ap-config-info.do`, params);
  },
  /**
   * 성능/운영 > 구성 > 변경이력 컨트롤러의 무선AP 변경이력 날짜를 조회한다.
   * @author Hunui
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getApConfigChangeHistDate(params) {
    return axios.post(`${baseUrl}/config/get-ap-config-hist-date.do`, params);
  },
  /**
   * 성능/운영 > 구성 > 변경이력 컨트롤러의 무선AP 변경이력을 조회한다.
   * @author Hunui
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  compareApConfigHist(params) {
    return axios.post(`${baseUrl}/config/compare-ap-controller-config-hist.do`, params);
  },
  getControllerConfigInfoList(params) {
    return axios.post(`${baseUrl}/config/get-controller-config-info-list.do`, params);
  },
  exportControllerConfigInfoDeviceList(params) {
    return axios.post(`${baseUrl}/config/export-controller-config-info-list.do`, params);
  },
  getWirelessApConfigInfoList(params) {
    return axios.post(`${baseUrl}/config/get-wireless-ap-config-info-list.do`, params);
  },
  exportWirelessApConfigInfoList(params) {
    return axios.post(`${baseUrl}/config/export-wireless-ap-config-info-list.do`, params);
  },
  getApControllerConfigApList(params) {
    return axios.post(`${baseUrl}/config/get-ap-controller-config-ap-list.do`, params);
  },
  exportApControllerConfigApList(params) {
    return axios.post(`${baseUrl}/config/export-ap-controller-ap-list.do`, params);
  },
  /**
   * 무선 AP를 재기동 한다.
   * @author Ju
   * @param  {Number} objId [description]
   */
  restartAp(objId) {
    return axios.post(`${baseUrl}/config/restart-ap.do`, { apObjId: objId });
  },
};



// WEBPACK FOOTER //
// ./src/api/config/wireless-device/wireless-device-info.js